// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3-xu_","col":"styles_col__3OSSz","fulfillmentStatus":"styles_fulfillmentStatus__3DF9k","emailCol":"styles_emailCol__56sXh"};